import script from "./ChatSidebarTopBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatSidebarTopBar.vue?vue&type=script&setup=true&lang=ts"

import "./ChatSidebarTopBar.vue?vue&type=style&index=0&id=5d4356db&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d4356db"]])

export default __exports__